import React, { RefObject, useEffect, useState } from 'react';

enum CheckboxState {
    Unchecked,
    Checked,
    Intermediate,
}

interface TriStateCheckboxProps {
    id: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: any;
    disabled?: boolean;
    intermediate: boolean;
    checked: boolean;
    customInputClass?: string;
    disabledClass?: string;
}

const TriStateCheckbox: React.FC<TriStateCheckboxProps> = ({ id, value, disabled, checked, intermediate, customInputClass, disabledClass, onChange }) => {
    // const [checkboxState, setCheckboxState] = useState<CheckboxState>(intermediate ? CheckboxState.Intermediate : checked ? CheckboxState.Checked : CheckboxState.Unchecked);
    const checkboxRef = React.useRef<any>();

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = intermediate;
            checkboxRef.current.checked = checked;
        }
    }, [checkboxRef, checked, intermediate])

    const handleCheckboxClick = () => {
        onChange && onChange({ target: { value, checked: true } } as React.ChangeEvent<HTMLInputElement>);
    };

    return (
        <div className={`tristate-checkbox flex relative`}>
            <input
                id={id}
                ref={checkboxRef}
                type="checkbox"
                onChange={handleCheckboxClick}
                disabled={disabled}
                className={`size-5 rounded-md ${customInputClass} ${disabledClass ? disabledClass : `disabled:bg-gray-200 disabled:border-gray-300`}`}
            />
            <span />
        </div>
    );
};

export default TriStateCheckbox;